<script setup lang="ts">
  import ModalQC from '@qicgroupdoha/qic-connect-ds/components/ModalQC'
  import ButtonQC from '@qicgroupdoha/qic-connect-ds/components/ButtonQC'
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'
  import { useI18n } from 'vue-i18n'

  const emit = defineEmits<{
    (e: 'keep', close: () => void): void
    (e: 'remove', close: () => void): void
    (e: 'close'): void
  }>()

  const { t, locale } = useI18n()
</script>

<template>
  <!-- @vue-ignore -->
  <ModalQC
    :title="t('visitors.fill_visitors_info.file_recognition.clear_dnd_modal.header.text')"
    :locale="locale"
    @close="emit('close')"
  >
    <template #after-title>
      {{ t('visitors.fill_visitors_info.file_recognition.clear_dnd_modal.sub_header.text') }}
    </template>
    <template #controls="{ close }">
      <WrapperQC direction="column" gap="var(--spacing-4)">
        <ButtonQC variant="primary" size="large" wide @click="emit('keep', close)">
          {{ t('visitors.fill_visitors_info.file_recognition.clear_dnd_modal.keep.button') }}
        </ButtonQC>
        <ButtonQC variant="outline" size="large" wide @click="emit('remove', close)">
          {{ t('visitors.fill_visitors_info.file_recognition.clear_dnd_modal.remove.button') }}
        </ButtonQC>
      </WrapperQC>
    </template>
  </ModalQC>
</template>
